import { finite } from "@/lib/science/units";

type Field = "mass" | "volume" | "percent";
export interface PercentSolutionInput {
  /** grams */
  mass: number | null;
  /** litres */
  volume: number | null;
  /** percent (w/v), g per 100 mL */
  percent: number | null;
}

// %(w/v) = mass(g) / volume(mL) × 100. In base units (g, L):
//   percent = mass / (volume × 10)   because volume_mL = volume_L × 1000.
// Exactly one field must be null (the unknown to solve for).
export function solvePercentWV(known: PercentSolutionInput): number | null {
  const nulls = (["mass", "volume", "percent"] as Field[]).filter(
    (k) => known[k] === null,
  );
  if (nulls.length !== 1) return null;
  const vals = [known.mass, known.volume, known.percent].filter(
    (n): n is number => n !== null,
  );
  if (!finite(...vals)) return null;

  const { mass, volume, percent } = known;
  switch (nulls[0]) {
    case "percent":
      return volume === 0 ? null : mass! / (volume! * 10);
    case "mass":
      return percent! * volume! * 10;
    case "volume":
      return percent === 0 ? null : mass! / (percent! * 10);
    default:
      return null;
  }
}
